import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../api"

export default function LatestGames() {

    const [playedGames, setPlayedGames] = useState([]);

  // fetch latest played games
useEffect(() => {
    api.get("user/games/played/")  // <-- Important: correct endpoint
      .then((res) => {
        setPlayedGames(res.data);  // <-- You need to create setPlayedGames state
      })
      .catch((err) => {
        console.error("Error loading played games:", err);
      });
  }, []);

    return (
        <div className="contentCol">
            <h2>{playedGames.length === 0 ? "anbefalet til dig" : "fortsæt hvor du slap"}</h2>
            <div className="gamesWindow">
                {/* No games played */}
                {playedGames.length === 0 ? (
                    <>
                        {/* Ligningsmesteren */}
                        <div className="gameCard">
                            <h3>ligningsmesteren</h3>
                            <img
                                src={`/images/ligningsmester.png`}
                                alt="ligningsmesteren"
                                className="h-32 w-32 rounded-lg mb-4"
                            />
                            <p className="text-sm">
                                Det originale ligningsspil. I tre niveauer.
                            </p>
                            <div className="flex justify-end mt-4">
                                <Link to={`/Drills/ligningsmester`}>
                                <button className="mt-4 px-4 py-2 bg-blue-500 font-nunito text-white rounded-lg">
                                    åben
                                </button>
                                </Link>
                            </div>
                        </div>
                        {/* Formelknuseren */}
                        <div className="gameCard">
                            <h2 className="text-lg font-nunito font-semibold">formelknuseren</h2>
                            <img
                                src={`/images/formelknuseren.png`}
                                alt="formelknuseren"
                                className="h-32 w-32 rounded-lg mb-4"
                            />
                            <p className="text-sm">
                                Kommende spil om formelbrug.
                            </p>
                            <div className="flex justify-end mt-4">
                                <Link to={`/Drills/formelknuseren`}>
                                <button className="mt-4 px-4 py-2 bg-blue-500 font-nunito text-white rounded-lg">
                                    åben
                                </button>
                                </Link>
                            </div>
                            {/* overlay */}
                            <div className="flex absolute inset-0 bg-gray-100 opacity-60 rounded-lg justify-center items-center text-2xl text-rose-500 font-bold">
                                <span className="rotate-45">kommer snart</span>
                            </div>
                        </div>
                        {/* Trigonometeren */}
                        <div className="gameCard">
                            <h2 className="text-lg font-nunito font-semibold">trigonometeren</h2>
                            <img
                                src={`/images/trigonometeren.png`}
                                alt="formelknuseren"
                                className="h-32 w-32 rounded-lg mb-4"
                            />
                            <p className="text-sm">
                                Kommende spil om trekanter.
                            </p>
                            <div className="flex justify-end mt-4">
                                <Link to={`/Drills/trigonometeren`}>
                                <button className="mt-4 px-4 py-2 bg-blue-500 font-nunito text-white rounded-lg">
                                    åben
                                </button>
                                </Link>
                            </div>
                            {/* overlay */}
                            <div className="flex absolute inset-0 bg-gray-100 opacity-60 rounded-lg justify-center items-center text-2xl text-rose-500 font-bold">
                                <span className="rotate-45">kommer snart</span>
                            </div>
                        </div>
                    </>
                ) : (
                // Latest played games
                playedGames.map((game, index) => (
                    <div key={index} className="gameCard">
                        <h3>{game.game_name}</h3>
                        <img
                            src={`/images/${game.game_name.toLowerCase()}_${game.level}.png`}
                            alt={game.game_name}
                            className="h-32 w-32 rounded-lg mb-4"
                        />
                        <h3 className="text-lg font-nunito font-semibold">kapitel {game.level}</h3>
                        <p className="text-sm">
                            Du er i gang med kapitel {game.level}. Et par minutter om dagen gør underværker!
                        </p>
                        <div className="flex justify-end mt-4">
                            <Link to={`/Drills/${game.game_name}_${game.level}`}>
                            <button className="mt-4 px-4 py-2 bg-blue-500 font-nunito text-white rounded-lg">
                                start
                            </button>
                            </Link>
                        </div>
                    </div>
                ))
                )}
            </div>
        </div>
    )
}